import { Link } from 'gatsby';
import WebUI1080Articles from 'components/Web_User_Interface/1440p_Series/Multimedia/IntroWebUIMultimedia1440';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  WebUI1080Articles,
  BreadCrumbs,
  SEOHelmet,
  React
};